import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import "./WalletComponent.css";
import moment from "moment";

const PointsAnalyticModal = ({
  show,
  handleClose,
  analyticData,
  pointSummaryData,
  setPointSummaryData,
  filterData,
  setFilteredData,
  getProfileData,
}) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const hanldeSelect = (e) => {
    document.getElementById("filterDate").value = "";

    const filter = pointSummaryData?.filter((i) => e === i?.RecievedWay);
    setFilteredData(filter);
  };
  const handleDate = (e) => {
    const filter = pointSummaryData?.filter((i) => {
      const itemDate = i?.Date.split("T")[0];
      return e === itemDate;
    });
    setFilteredData(filter);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        className="points_modal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="common_heading ">Points Analytics</h4>
            <button
              type="button"
              className="close popup_prode_close_btn"
              onClick={handleClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body wallet_body_modal_scroll">
            <div className="row ">
              <div className="col-lg-6">
                <h3 className="wallet_heading">Addition Points</h3>
                <div className="wallet_analytics_wraper">
                  <div>
                    <p>
                      <span className="wallet_analytics">Default Points </span>
                      <span className="pull-right">
                        {analyticData?.DefaultPoints}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p>
                      <span className="wallet_analytics">Clicked Points </span>
                      <span className="pull-right">
                        {analyticData?.ClickedPoints}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p>
                      <span className="wallet_analytics">
                        Earned By Banner View{" "}
                      </span>
                      <span className="pull-right">
                        {analyticData?.EarnedByBannerView}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p>
                      <span className="wallet_analytics">
                        Points By Referral{" "}
                      </span>
                      <span className="pull-right">
                        {analyticData?.PointsByReffral}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p>
                      <span className="wallet_analytics">
                        Points Received By Orders{" "}
                      </span>
                      <span className="pull-right">
                        {analyticData?.OrderRewardPoints}
                      </span>
                    </p>
                  </div>
                  {getProfileData?.IsInBusiness ? (
                    <>
                      <div>
                        <p>
                          <span className="wallet_analytics">
                            Become Affiliate Partner{" "}
                          </span>
                          <span className="pull-right">
                            {analyticData?.BecomeVendor}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span className="wallet_analytics">
                            Received By User Bid
                          </span>
                          <span className="pull-right">
                            {analyticData?.RecievedByUserBid}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span className="wallet_analytics">
                            Received By Add Points
                          </span>
                          <span className="pull-right">
                            {analyticData?.ReceivedFromAddMoney}
                          </span>
                        </p>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <h3 className="wallet_heading">Reduction Points</h3>
                <div className="wallet_analytics_wraper">
                  <div>
                    <p>
                      <span className="wallet_analytics">
                         Banner View Records Points
                      </span>
                      <span className="pull-right">
                        {analyticData?.DeductionByBannerViewRecordsPoints}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span className="wallet_analytics">
                         Banner View
                      </span>
                      <span className="pull-right">
                        {analyticData?.DeductionByBannerView}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span className="wallet_analytics">
                         Winning Points
                      </span>
                      <span className="pull-right">
                        {analyticData?.DeductionByWinningPoints}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer wallett_footer">
            <div className="row">
              <div className="col-12">
                <h4 className="wallet_balaance_points">
                  Balance Points : {analyticData?.BalancePoints}
                </h4>
              </div>
            </div>
          </div>
          <hr className="mb-0" />
          <div className="modal-header">
            <h4 className="modal-title common_heading">Points History</h4>
          </div>

          <div className="row align-items-center">
            <div className="col-md-6">
              <label for="cars">Select Filter</label>

              <select
                name="SelectHistoryDdl"
                className="form-select"
                id="SelectHistoryDdl"
                onChange={(e) => hanldeSelect(e?.target?.value)}
              >
                <option value="">Select</option>
                <option value="By first time login">By first time login</option>
                <option value="By referral" selected="">
                  By referral
                </option>
                <option value="Lucky points by first time login">
                  Lucky points by first time login
                </option>
                <option value="OrderRewardPoints">Order Reward Points</option>
                <option value="ReceivedFromLuckyChance">
                  Received From Lucky Chance
                </option>
                {getProfileData?.IsInBusiness ? (
                  <>
                    <option value="Become a Vendor">Become a Vendor</option>
                    <option value="DeductionByBannerView">
                      Deduction By Banner View
                    </option>
                    <option value="RecievedByUserBid">
                      Recieved By User Bid
                    </option>
                  </>
                ) : null}
              </select>
            </div>
            <div className="col-md-6">
              <label for="filterDate" className="form-label">
                {" "}
                Select Date:
              </label>
              <input
                type="date"
                className="form-control mb-2"
                id="filterDate"
                onChange={(e) => handleDate(e?.target?.value)}
              />
            </div>
          </div>

          <div className="modal-body wallet_body_modal_scroll ">
            <div className="table-responsive custom-table">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Date Recieved</th>
                    <th>Recieved From</th>
                    <th>Points</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData?.length
                    ? filterData?.map((item) => {
                        return (
                          <tr>
                            <td>
                              {moment(item?.Date).format(
                                "DD/MM/YYYY,  h:mm:ss a"
                              )}
                            </td>
                            <td>{item?.RecievedWay}</td>
                            <td>{item?.Points}</td>
                          </tr>
                        );
                      })
                    : "No Data Found"}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PointsAnalyticModal;
